<template>
  <ui-component-modal
    modalTitle="Delete space"
    :onClickCancel="onClickCancel"
    :showModal="showModal"
    :hideFooterButtons="isDeletingError || isDeletingSuccess"
    :buttonLabelConfirm="'Delete'"
    :isSaving="isDeleting"
    :isSavingSuccess="isDeletingSuccess"
    :savingSuccessMessage="'Space deleted'"
    :savingErrorMessage="'Oops, something went wrong.'"
    :isSavingError="isDeletingError"
    :onClickSave="deleteSpace"
    @closeModal="onClickCancel"
  >
    <template v-slot:content>
      <p>Are you sure you want to delete this space {{ space.SpaceName }}?</p>
    </template>
  </ui-component-modal>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { EventBus } from '@/eventbus/event-bus'
import cartProvider from '@/providers/cart'

export default {
  props: {
    space: {
      type: Object,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    },
    onClickCancel: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      isDeleting: false,
      isDeletingError: false,
      isDeletingSuccess: false
    }
  },

  computed: {
    ...mapState('cartStore', ['cart'])
  },

  methods: {
    ...mapMutations('cartStore', ['setCart']),

    deleteSpace() {
      let self = this
      self.isDeleting = true

      cartProvider.methods
        .deleteCartSpace(self.cart.CartKey, self.space.Id)
        .then(response => {
          if (response.status === 200) {
            self.setCart(response.data)

            self.isDeletingSuccess = true

            EventBus.$emit('showToast', {
              type: 'info',
              message: 'Option is deleted!'
            })

            setTimeout(() => {
              self.onClickCancel()
            }, 1500)
          }
        })
        .catch(error => {
          self.isDeletingError = true
        })
        .finally(() => {
          self.isDeleting = false
        })
    }
  }
}
</script>
